import { useEffect, useState } from "react";
import { Button, Modal, FormTextAreaInput } from "cai-fusion";
import { useTransientVisibility } from "../../../fusion/Contexts/VisualContext";
import { useDataStore } from "../../contexts/DataStoreContext";
import env from "../../../../configs/envConfig";

const DataStoreFileMetadataModal = ({fileItem, fileMetadata}) => {

	const [metadata, setMetadata] = useState("");
    const { visibilityStates, hide } = useTransientVisibility();
    const { updateFileMetadata } = useDataStore();

	useEffect(() => {
		if (visibilityStates.DataStoreFileMetadataModal) {
			setMetadata(fileMetadata ?? "");
		}
	}, [visibilityStates.DataStoreFileMetadataModal, fileMetadata])

    const onSubmit = () => {
        if (fileItem && fileItem.id) {
            updateFileMetadata(fileItem.id, metadata);
        }
    }

    const onClose = () => {
        hide('DataStoreFileMetadataModal');
        setMetadata("");
    }

	return (
		<Modal
			isHidden={!visibilityStates.DataStoreFileMetadataModal}
			clickOutsideToClose
			title="Edit File Notes"
			onClose={onClose}
			actions={
				<>
					<Button outline onClick={onClose} children="Cancel"/>
					<Button onClick={() => { onSubmit(); onClose();}} children="Save"/>
				</>
			}
		>
			<div className="l-row">
				<div className="l-one-col">
                    <p>You are modifying the file notes for <strong>{fileItem?.name ?? "a file"}</strong>. These notes will be used by {env.REACT_APP_BRANDING_SYMPHONY_NAME} to provide additional context and information to this file.</p>
					<FormTextAreaInput 
                        rows={5}
                        displayName="File Notes"
                        formValue={metadata}
                        onInputChange={(_, newValue) => setMetadata(newValue)}
                    />
				</div>
			</div>
		</Modal>
	);
};

export default DataStoreFileMetadataModal;